export default __webpack_public_path__ + "static/media/Grey_arrows.10cfb96b.gif";